import React from 'react'
import { ReactComponent } from './CircleBuildingIcon.svg'
import { MergeReactElementProps } from '../../types'

interface CircleBuildingIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', CircleBuildingIconProps>

export const CircleBuildingIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} strokeWidth="2px" ref={ref} {...props} />
  }
)
